import moment from "moment"

import { ADD_ALERT, REMOVE_ALERT } from "./action-types"
import {
    defaultErrorMessage,
    customErrorWithAction,
    loadingErrorMessage,
    analysingErrorMessage,
    saveSuccessMessage,
    saveErrorMessage,
    createSuccessMessage,
    deleteSuccessMessage,
    deleteErrorMessage,
    cancelChangesMessage,
    missingFieldMessage,
    overallInvalidInputMessage,
    toBeImplementedMessage
} from "../config/alert-message-definitions"

export const addAlert = (
    alertType,
    message,
    header,
    statusCode,
    timeout = 3000
) => ({
    type: ADD_ALERT,
    alertId: generateUUID(),
    receivedAt: moment(),
    alertType,
    message,
    header,
    statusCode,
    timeout
})

// Default error alert
export const addDefaultErrorAlert = statusCode =>
    addAlert("error", defaultErrorMessage, null, statusCode)

// Custom alerts
export const addCustomErrorAlert = (message, header = "Sorry!", statusCode) =>
    addAlert("error", message, header, statusCode)
export const addCustomActionErrorAlert = (
    action,
    itemType,
    name,
    header = "Sorry!",
    statusCode
) =>
    addCustomErrorAlert(
        customErrorWithAction(action, itemType, name),
        header,
        statusCode
    )
export const addCustomSuccessAlert = (message, header = "Success!") =>
    addAlert("success", message, header)
export const addCustomInfoAlert = (message, header) =>
    addAlert("info", message, header)
export const addCustomWarningAlert = (message, header) =>
    addAlert("warning", message, header)

// Loading alerts
export const addLoadingErrorAlert = (itemType, name) =>
    addCustomErrorAlert(loadingErrorMessage(itemType, name), "Loading error")
export const addAnalysingErrorAlert = (itemType, name) =>
    addCustomErrorAlert(
        analysingErrorMessage(itemType, name),
        "Analyzing error"
    )

// Saving alerts
export const addSaveSuccessAlert = name =>
    addCustomSuccessAlert(saveSuccessMessage(name), "Save successful")
export const addSaveErrorAlert = (itemType, name) =>
    addCustomErrorAlert(saveErrorMessage(itemType, name), "Save error")
export const addCreateSuccessAlert = name =>
    addCustomSuccessAlert(createSuccessMessage(name), "Save successful")

// Deleting alerts
export const addDeleteSuccessAlert = name =>
    addCustomSuccessAlert(deleteSuccessMessage(name), "Delete successful")
export const addDeleteErrorAlert = (itemType, name) =>
    addCustomErrorAlert(deleteErrorMessage(itemType, name), "Delete error")

// Cancelling alert
export const addCancelChangesAlert = name =>
    addCustomSuccessAlert(cancelChangesMessage(name))

// Invalidation alerts
export const addMissingFieldAlert = fieldName =>
    addCustomWarningAlert(missingFieldMessage(fieldName), "Required")
export const addInvalidInputAlert = () =>
    addCustomWarningAlert(overallInvalidInputMessage, "Required")

// Feature in development
export const addToBeImplementedAlert = featureName =>
    addCustomWarningAlert(toBeImplementedMessage(featureName), "Uh oh! 😱")

export const removeAlert = id => ({
    type: REMOVE_ALERT,
    alertId: id
})

// Public Domain/MIT
function generateUUID() {
    let dateTime = new Date().getTime()
    if (
        typeof performance !== "undefined" &&
        typeof performance.now === "function"
    )
        dateTime += performance.now() // use high-precision timer if available
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        const r = ((dateTime + Math.random() * 16) % 16) | 0
        dateTime = Math.floor(dateTime / 16)
        return (c === "x" ? r : (r & 0x3) | 0x8).toString(16)
    })
}
